import {useLocation} from 'react-router-dom';
import menuService from "@/services/menuService";

export const useDeliveryLocation = () => {
  const location = useLocation();

  return menuService.parse(location.pathname);
};
